module.exports = __webpack_public_path__ + "media/images/seeds/talljohn-335d1b8f7f6fabca2ca0da5f47dd44ab.jpg";